// The hub's sections — one list drives the desktop rail and the narrow
// top bar (components/AppShell.tsx), so adding a section is one entry
// here plus its route in App.tsx (docs/hub-plan.md, "Information
// architecture"). Tools joins when it's built.

export interface Section {
  id: string;
  label: string;
  /** Where the nav item links. */
  path: string;
  icon: string;
  /** Path prefixes that also light this item up (sub-pages of the section). */
  match: string[];
}

export const SECTIONS: Section[] = [
  { id: 'today', label: 'Today', path: '/', icon: 'sun', match: [] },
  // Reservations and plans outside trips (plan D19, routes/Plans).
  { id: 'plans', label: 'Plans', path: '/plans', icon: 'calendar', match: ['/plans'] },
  {
    id: 'ledger',
    label: 'Ledger',
    path: '/ledger',
    icon: 'receipt',
    // The expense and payment editors belong to the Ledger.
    match: ['/ledger', '/expense', '/settle'],
  },
  { id: 'trips', label: 'Trips', path: '/trips', icon: 'flight', match: ['/trips'] },
  // Apple Reminders lists mirrored by a Mac (routes/Lists, plan D22).
  { id: 'lists', label: 'Lists', path: '/lists', icon: 'checklist', match: ['/lists'] },
  // What email capture found that no trip took: reservations, suggested
  // expenses, and mail to look at (src/lib/intake.ts, plan D18).
  { id: 'inbox', label: 'Inbox', path: '/inbox', icon: 'inbox', match: ['/inbox'] },
  // H3a: published copies of the homelab pages (routes/Home, Dogs, Car).
  { id: 'home', label: 'Home', path: '/home', icon: 'home', match: ['/home'] },
  { id: 'dogs', label: 'Dogs', path: '/dogs', icon: 'paw', match: ['/dogs'] },
  { id: 'car', label: 'Car', path: '/car', icon: 'car', match: ['/car'] },
];

export const SETTINGS_SECTION: Section = {
  id: 'settings',
  label: 'Settings',
  path: '/settings',
  icon: 'settings',
  match: ['/settings'],
};

/** Whether `pathname` is inside `section`. Today matches only "/". */
export function isSectionActive(section: Section, pathname: string): boolean {
  if (section.match.length === 0) return pathname === section.path;
  return section.match.some((p) => pathname === p || pathname.startsWith(`${p}/`));
}
